export const environment = {
  production: false,
  name: 'docker-compose',
  apiUrl: '/api', // Relative path routed through NGINX proxy to backend
  frontendUrl: 'http://localhost:8080'
};
